import styled from 'styled-components';
import { flexbox, alignItems, flexDirection } from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

const InfoWrapper = styled.div((props) => {
  const { palette } = ThemeHelper.getTheme(props);
  return `
        ${flexbox()};
        ${alignItems('flex-start')};
        flex-direction: column;
        color: ${palette.primary.dark};
        width: 100%;
        
        div {
          padding: 10px;
          font-family: inherit;
          font-size: 12px;
          width: 100%;
          box-sizing: border-box;
        }
        .description {
          padding-top: 0;
        }
        .headerWrapper {
          ${flexbox()};
          ${flexDirection('row')};
          font-weight: 600;
          
          .title {
            ${flexDirection('column')};
          }
          .subTitle {
            padding-top: 5px;
          }
          * {
            padding: 0;
          }
        }
`;
});

const Icon = styled.span`
  width: 37px;
  min-height: 37px;
  padding-left: 15px !important;
  margin-top: 5px;
  text-align: right;
`;

const Hide = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
  ${flexbox()};
  ${alignItems('left')};  
  
  cursor: pointer;
  border-bottom: 1px solid ${colours.grey[400]};
  padding: 8px;
  font-family: inherit;
  font-size: 12px;
  width: 100%;
  box-sizing: border-box;
  `;
});

export { InfoWrapper, Icon, Hide };
